import { HttpHeaders } from '@angular/common/http';
import { HostListener } from '@angular/core';
import { CommonTranslationService, ShellDomainProvider, TranslationResourceModel } from '@ecap3/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class DeltaMobileAppCentralizedTranslationLoader {
	private http = undefined;
	private resources = undefined;
	private langArray = undefined;
	headers = new HttpHeaders({
		'x-blocks-key': ShellDomainProvider['api'].UilmXBlocksKey
	  });

	constructor(http, resources) {
		this.http = http;
		this.resources = resources;
		this.langArray = [];
	}

	private getLocaleFromLang(lang: string): string {
		const localeMap: { [key: string]: string } = {
			'en': 'en-US',
			'de': 'de-DE',
			'it': 'it-IT'
		};
		return localeMap[lang] || lang;
	}

	getTranslation(lang): Observable<any> {
		const commonTranslationResource = new TranslationResourceModel('GenericApp');
		let hasCommonTranslations = false;
		let commonTranslationIndexInResource = -1;
		if (CommonTranslationService.lastLanguage !== lang) {
			CommonTranslationService.translation = undefined;
		}
		CommonTranslationService.lastLanguage = lang;
		if (CommonTranslationService.translation) {
			hasCommonTranslations = true;
			this.resources.filter((item) => {
				return item.prefix !== commonTranslationResource.prefix;
			});
		} else {
			commonTranslationIndexInResource = this.resources.findIndex((item) => {
				return item.prefix === commonTranslationResource.prefix;
			});
			if (commonTranslationIndexInResource === -1) {
				commonTranslationIndexInResource = this.resources.length;
				this.resources.push(commonTranslationResource);
			}
		}

		const isLoadTranslationsCentrally = ShellDomainProvider['api'].loadTranslationsCentrally;
		const isLanguageSpecificTranslationLoaded = JSON.parse(sessionStorage.getItem(lang));

		// If translations already saved on session storage then return from the session storage
		if (isLoadTranslationsCentrally && isLanguageSpecificTranslationLoaded) {
			return of(JSON.parse(sessionStorage.getItem(lang)));
		}

		// User press reload icon, or it's the initial load ? this will load
		const requests = this.resources.map((resource) => {
			const locale = this.getLocaleFromLang(lang);
			const path = resource.prefix + locale + resource.suffix;
			// GET call to UILM resource
			return this.http.get(path, { withCredentials: true , headers: this.headers}).pipe(
				catchError((res) => {
					console.error('Could not find translation file:', path);
					return of({});
				})
			);
		});
		return forkJoin(requests).pipe(
			map((responseJsons: any[]) => {
				responseJsons = responseJsons.filter((res) => res !== null);
				let mergeAll = {};
				if (hasCommonTranslations) {
					mergeAll = CommonTranslationService.translation;
				} else {
					CommonTranslationService.translation = responseJsons[commonTranslationIndexInResource];
				}
				responseJsons.forEach((response) => this.mergeDeep(mergeAll, response));

				// Save Translations to session storage for further reuse without giving api call
				sessionStorage.setItem(lang, JSON.stringify(mergeAll));
				return mergeAll;
			})
		);
	}
	mergeDeep(target, source) {
		if (typeof target === 'object' && typeof source === 'object') {
			Object.keys(source).forEach((key) => {
				if (source[key] === null && (target[key] === undefined || target[key] === null)) {
					target[key] = null;
				} else if (source[key] instanceof Array) {
					if (!target[key]) {
						target[key] = [];
					}
					target[key] = target[key].concat(source[key]);
				} else if (typeof source[key] === 'object') {
					if (!target[key]) {
						target[key] = {};
					}
					this.mergeDeep(target[key], source[key]);
				} else {
					target[key] = source[key];
				}
			});
		}
		return target;
	}
}
